<template>
  <div>
    <GlobalTable
      :title="title+' List'"
      :fields="fields"
      :items="items"
      :editButton="false"
      :redirectDetail="false"
      :isLoading="isLoading"
      @addForm="addForm"
      @editForm="editForm"
      :enableAddButton="false"
    ></GlobalTable>

    <CModal
      title="Modal title"
      color="success"
      size="xl"
      :closeOnBackdrop="false"
      :show.sync="addButton"
    >
      <template #header>
        <h6 class="modal-title">Add Form {{title}}</h6>
      </template>

      <Loading v-if="isLoading"></Loading>
      <div v-else>
        <CForm>
          <CRow>
            <CCol sm="3">
              <CInput
                label="Villages Name"
                invalid-feedback="Villages name should be filled"
                required
                :readonly="readon"
                v-model="$v.villagesForm.name.$model"
                :is-valid="!$v.villagesForm.name.$invalid"
              />
            </CCol>
            <CCol sm="3">
              <div class="form-group">
                <label for="district">District</label>
                <model-select
                  class="form-control"
                  id="district"
                  :options="districtList"
                  v-model="$v.villagesForm.district_id.$model"
                  :isError="$v.villagesForm.district_id.$invalid"
                  placeholder="-- Harap pilih salah satu --"
                ></model-select>
                <div
                  v-if="$v.villagesForm.district_id.$invalid"
                  class="invalid-feedback-custom"
                >District should be filled.</div>
              </div>
            </CCol>
            <CCol sm="3">
              <CInput
                label="Villages Code"
                invalid-feedback="Villages code should be filled"
                required
                v-model="$v.villagesForm.villages_code.$model"
                :is-valid="!$v.villagesForm.villages_code.$invalid"
              />
            </CCol>
          </CRow>
          <CRow>
            <CCol sm="12">
              <label for="nik">Description</label>
              <quill-editor style="height: 200px; margin-bottom:70px;"
                :content="content"
                :options="editorOption"
                v-model="$v.villagesForm.description.$model"
                @change="onEditorChange($event)">
              </quill-editor>
              <div v-if="$v.villagesForm.description.$invalid" class="invalid-feedback-custom">
                Description harus di isi.
              </div>
              <!-- <CTextarea
                rows="4"
                label="Description"
                invalid-feedback="Description should be filled"
                required
                v-model="$v.productCategoryForm.description.$model"
                :is-valid="!$v.productCategoryForm.description.$invalid"
              /> -->
            </CCol>
          </CRow>
        </CForm>
      </div>

      <template #footer>
        <CButton @click="cancelForm" color="danger">
          <i class="fa fa-undo"></i>
          Cancel
        </CButton>
        <CButton @click="submitForm" :disabled="$v.villagesForm.$invalid" color="success">
          <i class="fa fa-save"></i>
          Accept
        </CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import GlobalTable from "../../../templates/Table";
import axios from "axios";
import tableInterfaces from "@/templates/_table_interfaces.js";
import { required } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import Loading from "../../../templates/Loading";

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'
import Quill from 'quill'

export default {
  name: "Villages",
  components: { GlobalTable, Loading, quillEditor },
  data() {
    return {
      title: "Villages",
      fields: [
        { key: "name", label: "Nama Desa", sorter: true },
        { key: "villages_code", label:"Kode Desa", sorter: true},
        { key: "zipcode", label:"Kode Pos", sorter: true},
        { key: "description", label: "Description", sorter: true },
        // { key: "action", _classes: "text-center action" },
      ],
      items: [],
      villagesForm: tableInterfaces.villages,
      isLoading: false,
      addButton: false,
      isEdit: false,
      readon:false,
      districtList:[],
       options: [
        { value: "1", label: "Yes" },
        { value: "0", label: "No" },
      ],
      content: '',editorOption: {},	// data quill
    };
  },
  validations: {
    villagesForm: {
      name: { required },
      villages_code: { required },
      zipcode: { required },
      description: {},
      district_id:{required},
    },
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  methods: {
    init: function () {
      this.isEdit = false;
      this.cancelForm();
      this.getVillage();
      this.getDistrictList();
    },
    getVillage: function () {
      this.isLoading = true;
      this.axios
        .get("console/master/villages/listing")
        .then((response) => {
          if (response.data.status === 2000) {
            this.items = response.data.data;
            this.showInfoNotification({
              title: this.title,
              message: response.data.message,
            });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
     getDistrictList: function(){
      this.axios.get("console/dropdown/district/regencies").then((response) => {
        this.districtList = response.data.data;
      });
    },
    addForm: function () {
      this.addButton = true;
      this.resetForm();
    },
    cancelForm: function () {
      this.addButton = false;
      this.resetForm();
      this.readon = false;
    },
    editForm: function (item) {
      this.addForm();
      this.isEdit = true;
      this.villagesForm = item;
      this.readon = true;
    },
    resetForm: function () {
      for (var i in tableInterfaces.district) {
        tableInterfaces.district[i] = null;
      }
      this.villagesForm = tableInterfaces.district;
    },
    submitForm: function (event) {
      event.preventDefault();
      if (this.isEdit === true) {
        if (confirm("Do you want to change this data ?")) {
          this.isLoading = true;
          this.axios
            .put("console/master/villages/edit", this.villagesForm)
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: this.title,
                  message: response.data.message,
                });
              } else {
                this.showErrorNotification({
                  title: this.title,
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.showErrorNotification({
                title: this.title,
                message: error,
              });
            })
            .finally(() => {
              this.isLoading = false;
              this.init();
            });
        }
      } else {
        if (confirm("Do you want to add this data ?")) {
          this.isLoading = true;
          this.axios
            .post("console/master/villages/add", this.villagesForm)
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: this.title,
                  message: response.data.message,
                });
              } else {
                this.showErrorNotification({
                  title: this.title,
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.showErrorNotification({
                title: this.title,
                message: error,
              });
            })
            .finally(() => {
              this.isLoading = false;
              this.init();
            });
        }
      }
    },
  },
  onEditorChange({ quill, html, text }) {
    this.content = html
    this.villagesForm.description = html
  },
  mounted() {
    this.init();
  },
};
</script>
